import React from "react";
import "./registerNow.scss";
import { homeURL } from "../../helpers/paths";

const RegisterNow = () => {
  return (
    <>
      <div className="regist_cta_container">
        <a href={`${homeURL}#register`} className="reg_cta">
          REGISTER NOW
        </a>
      </div>
    </>
  );
};

export default RegisterNow;
